import confirmationPageMixin from "@/pages/confirmation/mixin";

export default {
  mixins: [confirmationPageMixin],
  metaInfo() {
    const title = "Poznaj ideę podróży dopasowanej do Ciebie - Getaway";
    const description =
      "Poznaj ideę Getaway - podróże dopasowane do Twoich potrzeb. Sprawdź, jak szybko, wygodnie i bez stresu otrzymać idealną propozycję wyjazdu jak z Twoich marzeń.";
    return {
      title,
      meta: [
        {
          property: "og:title",
          content: title,
          vmid: "og:title",
        },
        {
          property: "og:description",
          content: description,
          vmid: "og:description",
        },
        {
          name: "description",
          content: description,
          vmid: "description",
        },
      ],
    };
  },
};
